import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import * as serviceWorker from './serviceWorker';
import RenderLanguage from "./components/Services/RenderLanguage";
import ReactGA from 'react-ga';

const runApp = () => {

  //Global site tag (gtag.js) - Google Analytics
  ReactGA.initialize("UA-51148150-1");
  ReactGA.pageview(window.location.pathname + window.location.search);

  ReactDOM.render(
    <React.StrictMode>
      <RenderLanguage>
        <App />
      </RenderLanguage>
    </React.StrictMode>,
    document.getElementById("app")
  );
}

if (!window.Intl || !window.Intl.PluralRules) {
  // eslint-disable-next-line no-restricted-properties
  require.ensure([], () => {
    require("@formatjs/intl-getcanonicallocales/polyfill");
    require("@formatjs/intl-locale/polyfill");
    require("@formatjs/intl-pluralrules/polyfill");
    require("@formatjs/intl-pluralrules/locale-data/en");
    require("@formatjs/intl-pluralrules/locale-data/fa");
    require("@formatjs/intl-numberformat/polyfill");
    require("@formatjs/intl-numberformat/locale-data/en");
    require("@formatjs/intl-numberformat/locale-data/fa");
    runApp();
  })
  runApp();
} else {
  runApp();
}

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
